export const contracts = {
	table: {
		columns: {
			status: "Status",
			contractId: "Contract ID",
			requestType: "Request Type",
			requestedAt: "Requested At",
			signatory: "Signatory",
			assignedAt: "Assigned At",
			expiredAt: "Expired At",
		},
		actionsTable: {
			seeContract: "See Contract",
			resendEmail: "Resend Clicksign Email",
		},
		solicitationType: {
			temporary: "Temporary",
			permanent: "Permanent",
		},
	},
	filter: {
		contractID: "Filter by contract ID",
		status: "Filter by status",
	},
	status: {
		pendingSignature: "Pending signature",
		signatureExpired: "Signature expired",
		contractExpired: "Contract expired",
		active: "Active contract",
		closed: "Closed contract",
	},
	title: "Contracts",
	header: {
		title: "Contracts",
		description: "Track your equipment and subscription requests",
	},
	xlsxFile: {
		filename: "contracts",
		tableTitle: "Contracts",
		columns: {
			id: "ID",
			status: "Status",
			createdAt: "Created At",
			updatedAt: "Updated At",
			requestType: "Request Type",
			requestModel: "Request Model",
			contractPeriod: "Contract Period",
			signatory: "Signatory",
			assignedAt: "Assigned At",
			expiredAt: "Expired At",
		},
	},
	sendEmailMessage: "Email successfully re-sent",
};
